import is from '@sindresorhus/is';
import type { RefObject } from 'react';
import { useEffect } from 'react';

export const useScrollToBottom = (ref: RefObject<HTMLElement | null>, deps: readonly unknown[]): void => {
    useEffect(() => {
        const node = ref.current;
        if (is.null(node)) return;
        node.scrollTop = node.scrollHeight;
        // biome-ignore lint/correctness/useExhaustiveDependencies: caller passes the values that should trigger the scroll.
    }, deps);
};
